import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';


const baseURL = environment.baseURL;

export const ApiUrls = {
    versionAndroidAPI: `${baseURL}api/app_version/LastVersionAndroid`,
    versioniOSAPI: `${baseURL}api/app_version/LastVersionIOS`,
    deleteJobList: `${baseURL}api/job_requirement/Delete`,
    jobCreate: `${baseURL}api/job_requirement/Create`,
    jobDetails: `${baseURL}api/job_requirement/Index`,
    jobDetailsId: `${baseURL}api/job_requirement/Details/`,
    jobPhoto: `${baseURL}api/job_requirement/upload`,
    userLogin: `${baseURL}api/user/SignIn`,
    userRegister: `${baseURL}api/user/SignUp`,
    userSignUp: `${baseURL}api/user/Create`,
    userLogout: `${baseURL}api/user/Logout`,
    userPhoto: `${baseURL}upload`,
    userList: `${baseURL}api/user/Details/`,
    memberList: `${baseURL}api/user/allmainmembers`,
    adminMemberList: `${baseURL}api/user/allmainmembersAdmin`,
    allMemberList: `${baseURL}api/user/index`,
    verifiedMemberList: `${baseURL}api/user/crud`,
    listByMemberId: `${baseURL}api/user/ListbyMeberid/`,
    cityList: `${baseURL}api/city/Index`,
    cityListById: `${baseURL}api/city/Details/`,
    addCity: `${baseURL}api/city/Create`,
    districtList: `${baseURL}api/district/Index`,
    addDistrict: `${baseURL}api/district/Create`,
    editDistrict: `${baseURL}api/district/crud`,
    AllSubdivisionList: `${baseURL}api/subdivision/Index`,
    subdivisionList: `${baseURL}api/subdivision/Details/`,
    subdivisionListSelect: `${baseURL}api/subdivision/Details/`,
    villageListSelect: `${baseURL}api/village/Details/`,
    getAllVillage: `${baseURL}api/village/Index/`,
    addSubdivision: `${baseURL}api/subdivision/Create`,
    editSubdivision: `${baseURL}api/subdivision/crud`,
    addVillage: `${baseURL}api/village/Create`,
    editVillage: `${baseURL}api/village/crud`,
    villageList: `${baseURL}api/village/Details/`,
    relationList: `${baseURL}api/relation/Index`,
    allMainMemberList: `${baseURL}api/user/allmainmembers`,
    getAllVillageList: `${baseURL}api/village/Index`,
    addBusiness: `${baseURL}api/business/Create`,
    businessPhoto: `${baseURL}api/business/upload`,
    businessList: `${baseURL}api/business/Index`,
    businessDetailsId: `${baseURL}api/business/Details/`,
    selectByTypeId: `${baseURL}api/user/selectbytype/`,
    dashboardCount: `${baseURL}api/user/count`,
    dashboardCountAll: `${baseURL}api/user/countAll/`,
    doctorList: `${baseURL}api/doctor/Index`,
    addDoctor: `${baseURL}api/doctor/Create`,
    doctorDetailsById: `${baseURL}api/doctor/Details/`,
    doctorPhoto: `${baseURL}upload`,
    eventList: `${baseURL}api/events/Index`,
    addEvent: `${baseURL}api/events/Create`,
    subEventList: `${baseURL}api/sub_event/Details/`,
    crudSubEvent: `${baseURL}api/sub_event/Create`,
    getSubEventInvitedMember: `${baseURL}api/sub_event_member/Details/`,
    sendInvitationToMember: `${baseURL}api/sub_event_member/Create`,
    presentMember: `${baseURL}api/event_attendance/Details/`,
    attendanceMember: `${baseURL}api/event_attendance/Create`,
    getSubEventDonorList: `${baseURL}api/sub_event_donor/Details/`,
    addEventDonor: `${baseURL}api/sub_event_donor/Create`,
    addEventDonorAll: `${baseURL}api/sub_event_donor/Index`,
    attendanceMemberCrud: `${baseURL}api/event_attendance/crud`,
    memoryAllData: `${baseURL}api/gallery_folder/Index`,
    memoryAllList: `${baseURL}api/gallery_folder/Details/`,
    memoryFolderCreate: `${baseURL}api/gallery_folder/crud`,
    getGalleryPhoto: `${baseURL}api/gallery/Details/`,
    getGalleryVideo: `${baseURL}api/video_gallery/Details/`,
    addGallery: `${baseURL}api/gallery/Create`,
    addPhotoInGallery: `${baseURL}api/gallery/upload`,
    addVideoGallery: `${baseURL}api/video_gallery/Create`,
    uploadVideoGallery: `${baseURL}api/video_gallery/upload`,
    sendContactUs: `${baseURL}api/contactUs/Create`,
    contactUsList: `${baseURL}api/contactUs/Index`,
    yearList: `${baseURL}api/committee_member/Years`,
    selectedYearWiseCommitteeList: `${baseURL}api/user/selectbytypeandyear/`,

    //notification api 
    addNotification: `${baseURL}api/notification/Create`,
    getNotification: `${baseURL}api/notification/Details/`,
    userTypeList: `${baseURL}api/user_type/Index`,

    //user-post api 
    addUserPost: `${baseURL}api/post/Create`,
    adminUserPostList: `${baseURL}api/post/SelectAll`,
    userPostList: `${baseURL}api/post/Index`,
    yourPostById: `${baseURL}api/post/Details/`,
    postDelete: `${baseURL}api/post/Delete/`,

    //water reminder api
    addWaterTarget: `${baseURL}api/water/crud`,
    addWaterConsumption: `${baseURL}api/water_consumption/crud`,
    sumOfWaterConsumption: `${baseURL}api/water_consumption/SUM/`,
    getTotalWaterIntake: `${baseURL}api/water_consumption/Details/`,

    //Sleep reminder api
    addEditSleepReminder: `${baseURL}api/sleep/crud`,
    historySleep: `${baseURL}api/sleep/Details/`,
    sleepStatus: `${baseURL}api/sleep/crud`,

    //Medicine reminder api
    addEditMedicineReminder: `${baseURL}api/medicine_reminder/crud`,
    medicineSleep: `${baseURL}api/medicine_reminder/Details/`,
    medicineStatus: `${baseURL}api/medicine_reminder/crud`,


    //Custom reminder api
    addEditCustomReminder: `${baseURL}api/custom_reminder/crud`,
    customReminderDetail: `${baseURL}api/custom_reminder/Details/`,

    statusChange: `${baseURL}api/contactUs/Create`,

}